import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useLoad } from '../../collection/Hooks';
import { apiGet } from '../../utils/api';
import { BsButton, BsCard, BsForm, BsFormControl, BsFormSelect } from '../../collection/bootstrap/BootstrapComponents';

/**
 * Filter for UsuariosTable.
 * Props:
 * - onFilter(data): Función que se ejecuta cuando se debe actualizar la tabla, la función recibe los datos del formulario de filtro y debe devolver la tabla resultante.
 * - defaultValue: Valores por defecto del filtro.
 * - selectDepartamento, selectLocalidad, selectConvenio : Si se incluyen estas propiedades, el filtro incluirá los respectivos campos.
 */
export default function UsuariosFilter(props) {
    const { defaultValue, onFilter, ...otherProps } = props;

    const updateData = () => defaultValue;
    const saveData = async data => {
        if (!data.get("departamentos[]"))
            data.delete("departamentos[]");
        await onFilter(data);
    }

    return <BsForm
        onUpdate={updateData}
        onSave={saveData}>
        <UsuariosFilterForm {...props} />
    </BsForm>;
}

function UsuariosFilterForm(props) {
    const data = props.data;

    // listas entidades
    var [departmentList] = useLoad(props.selectDepartamento ? async () => await apiGet("departamentos/list") : null);
    var [cityList] = useLoad(props.selectLocalidad ? async () => await apiGet("localidades/list") : null);
    var [convenioList] = useLoad(props.selectConvenio ? async () => await apiGet("convenios/list") : null);

    return <>
        <BsCard header="Filtro" className={props.className}>
            <>
                <Row className="gy-3 mb-3">
                    {/* Nombre */}
                    <Col md="6">
                        <BsFormControl
                            label="Nombre" name="nombre"
                            value={data.nombre} />
                    </Col>
                    {/* Apellidos */}
                    <Col md="6">
                        <BsFormControl
                            label="Apellidos" name="apellidos"
                            value={data.apellidos} />
                    </Col>
                </Row>
                {(props.selectDepartamento || props.selectLocalidad) && <>
                    <Row className="gy-3 mb-3">
                        {props.selectDepartamento && <>
                            {/* Departamentos */}
                            <Col md="6">
                                <BsFormSelect
                                    label="Departamento" name="departamentos[]"
                                    value={data.departamento} options={departmentList}
                                    isClearable isMulti />
                            </Col>
                        </>}
                        {props.selectLocalidad && <>
                            {/* Localidad */}
                            <Col md="6">
                                <BsFormSelect
                                    label="Localidad" name="localidadId"
                                    value={data.localidadId} options={cityList} isClearable />
                            </Col>
                        </>}
                    </Row>
                </>}
                {props.selectConvenio && <>
                    <Row className="gy-3 mb-3">
                        {/* Convenio */}
                        <Col md="6">
                            <BsFormSelect
                                label="Convenio" name="convenioId"
                                value={data.convenioId} options={convenioList} isClearable />
                        </Col>
                    </Row>
                </>}
                <div className="d-flex justify-content-center gap-3 mt-3">
                    <BsButton onClick={props.onSubmit}>Mostrar resultados</BsButton>
                </div>
            </>
        </BsCard>
    </>
}
